export var graphVariantsColorsTone = {
    primary: {
        '100': '--primary-color-01-100',
        '200': '--primary-color-01-200',
        '300': '--primary-color-01-300',
        '400': '--primary-color-01-400',
        '500': '--primary-color-01-500',
        '600': '--primary-color-01-600',
        '700': '--primary-color-01-700',
        '800': '--primary-color-01-800',
    },
    'primary-02': {
        '400': '--primary-color-02-400',
        '500': '--primary-color-02-500',
        '600': '--primary-color-02-600',
        '700': '--primary-color-02-700',
        '800': '--primary-color-02-800',
        '900': '--primary-color-02-900',
    },
    secondary: {
        '50': '--secondary-color-01-50',
        '100': '--secondary-color-01-100',
        '200': '--secondary-color-01-200',
        '300': '--secondary-color-01-300',
        '400': '--secondary-color-01-400',
        '500': '--secondary-color-01-500',
        '600': '--secondary-color-01-600',
        '700': '--secondary-color-01-700',
    },
    'secondary-02': {
        '200': '--secondary-color-02-200',
        '300': '--secondary-color-02-300',
        '400': '--secondary-color-02-400',
        '500': '--secondary-color-02-500',
        '600': '--secondary-color-02-600',
        '700': '--secondary-color-02-700',
        '800': '--secondary-color-02-800',
        '900': '--secondary-color-02-900',
    },
    'secondary-03': {
        '500': '--secondary-color-03-500',
        '600': '--secondary-color-03-600',
        '700': '--secondary-color-03-700',
        '800': '--secondary-color-03-800',
        '900': '--secondary-color-03-900',
    },
    'secondary-04': {
        '700': '--secondary-color-04-700',
        '800': '--secondary-color-04-800',
        '900': '--secondary-color-04-900',
    },
    'secondary-05': {
        '800': '--secondary-color-05-800',
        '900': '--secondary-color-05-900',
    },
    support: {
        '800': '--support-color-01-800',
        '900': '--support-color-01-900',
    },
    'support-03': {
        '500': '--support-color-03-500',
        '600': '--support-color-03-600',
        '700': '--support-color-03-700',
        '800': '--support-color-03-800',
        '900': '--support-color-03-900',
    },
    'support-05': {
        '300': '--support-color-05-300',
        '400': '--support-color-05-400',
        '500': '--support-color-05-500',
        '600': '--support-color-05-600',
        '700': '--support-color-05-700',
        '800': '--support-color-05-800',
        '900': '--support-color-05-900',
    },
    'support-02': {
        '800': '--support-color-02-800',
        '900': '--support-color-02-900',
    },
    'support-04': {
        '300': '--support-color-04-300',
        '400': '--support-color-04-400',
        '500': '--support-color-04-500',
        '600': '--support-color-04-600',
        '700': '--support-color-04-700',
        '800': '--support-color-04-800',
        '900': '--support-color-04-900',
    },
};
export var getVariants = function (color, tone) {
    var variantColor = graphVariantsColorsTone[color];
    return variantColor[tone];
};
export var uppercaseOnlyFirstLetter = function (text, maxTextLength) {
    if (!text)
        return '';
    var aux = text.toLowerCase().split(' ');
    aux = aux.map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); });
    text = aux.join(' ');
    if (maxTextLength && text.length > maxTextLength) {
        text = textEllipsis(text, maxTextLength);
    }
    return text;
};
export var textEllipsis = function (text, maxTextLength) {
    return text.length > maxTextLength
        ? "".concat(text.substring(0, maxTextLength), "...")
        : text;
};
export var formatCurrency = function (textNumber) {
    if (!textNumber) {
        textNumber = '0';
    }
    return Number(textNumber).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
    });
};
